class EventBusConstants {
  static readonly SECTION_CHANGE: string = 'section_change';
  static readonly ITEM_PICKED: string = 'item_picked';
  static readonly REVIEW_SUBMIT_BUTTON_CLICKED = 'review_submit_button_clicked';
  static readonly REVIEW_SUBMIT: string = 'review_submit';
  static readonly NAVIGATION_EVENT: string = 'navigation_event';
  static readonly HARD_TIMER_EVENT: string = 'hard_timer_expired';
  static readonly PAUSE_OVERLAY_BUTTON_CLICKED = 'pause_overlay_button_clicked';
  static readonly PAUSE_BUTTON_CLICKED = 'pause_button_clicked';
  static readonly TEST_REVIEW_EVENT = 'test_review_event';
  static readonly PNP_ITEM_CLICKED = 'pnp_item_clicked';
  static readonly PROCTOR_RELEASE: string = 'proctor_release';
  static readonly NETWORK_ERROR: string = 'network_error';
  static readonly APPLICATION_ERROR: string = 'application_error';
  static readonly SCHEDULED_EVENT: string = 'scheduled_event';
  static readonly PAUSE_EVENT: string = 'pause_event';
  static readonly HARD_TIMER_SECTION_LOGOUT: string = 'hard_timer_section_logout';
}

export default EventBusConstants;
